module.exports = __webpack_public_path__ + "img/shield-exclamation.8eb1ff22.svg";